<template>
    <div class="group-bg-main">
        <headerUnseenComponent :bannerArray="bannerArray"></headerUnseenComponent>
       
        <div class="st attractiondtl-slide-sec pd">
            <div class="container ">
                <div class="position-relative">
                    <div class="fw box-content">
                        <div class="arttraction-swiper fw">
                            <div class="box-arttraction-slide">
                                <div class="swiper arttraction_slide">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <div class="attrac-img-con">
                                                <img class="attrac-img"
                                                    src="@/assets/list-detail/north/phetchabun/phetchabun-01.jpg" alt="">
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="attrac-img-con">
                                                <img class="attrac-img"
                                                    src="@/assets/list-detail/north/phetchabun/phetchabun-02.jpg" alt="">
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="attrac-img-con">
                                                <img class="attrac-img"
                                                    src="@/assets/list-detail/north/phetchabun/phetchabun-03.jpg" alt="">
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="attrac-img-con">
                                                <img class="attrac-img"
                                                    src="@/assets/list-detail/north/phetchabun/phetchabun-04.jpg" alt="">
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="attrac-img-con">
                                                <img class="attrac-img"
                                                    src="@/assets/list-detail/north/phetchabun/phetchabun-05.jpg" alt="">
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="attrac-img-con">
                                                <img class="attrac-img"
                                                    src="@/assets/list-detail/north/phetchabun/phetchabun-06.jpg" alt="">
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="attrac-img-con">
                                                <img class="attrac-img"
                                                    src="@/assets/list-detail/north/phetchabun/phetchabun-07.jpg" alt="">
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="st attractiondtl-detail-sec pd">
            <div class="container ">
                <div class="position-relative">
                    <div class="fw box-content ">
                        <img src="@/assets/list-detail/north/phetchabun/phetchabun-attrac-detail.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
        <unseenComponent></unseenComponent>

    </div>
    <loadPageComponent v-if="isloade" class="loadpage-com" :class="isloade == true ? isActive : isActive = '' "></loadPageComponent>

</template>

<script>
/* eslint-disable */

import { playVideo } from '@/global'
import { setFunction } from '@/global'
import popupDetail from '@/components/popup/popupDetail.vue';
import unseenComponent from '@/components/25_unseenComponent.vue'
import headerUnseenComponent from '@/components/headerUnseenComponent.vue';
import loadPageComponent from '@/components/loadPageComponent.vue';

// SWIPER
import Swiper, { Autoplay, Navigation, Pagination, Controller, EffectFade, } from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination, Controller, EffectFade]);
import "swiper/swiper-bundle.css";
import 'swiper/css/pagination';

export default {
    name: 'petchabunDetailView',
    components: { popupDetail,unseenComponent,headerUnseenComponent,loadPageComponent },



    data() {
        return {
            isloade: true,
            isActive:'active',
            attractionSlideInit: null,
            hidePreview: true,
            locationSlideInit: null,
            cardContent: '',
            cardImageArray: [],
            images: [
                'central/prachuap-khiri-khan/prachuap-khiri-khan-1.jpg',
                'central/prachuap-khiri-khan/prachuap-khiri-khan-1.jpg',
                'central/prachuap-khiri-khan/prachuap-khiri-khan-1.jpg',
                'central/prachuap-khiri-khan/prachuap-khiri-khan-1.jpg',


            ],
            galleryTop: null,
            galleryThumbs: null,
            popupContArray: [],
            show: false,
            bannerArray:[{
                image_d: 'north/phetchabun/phetchabun-detail-banner.jpg',
                image_m: 'north/phetchabun/phetchabun-detail-banner-m.jpg',
                title: 'มหัศจรรย์น้ำตกหมอกเมืองไทย',
                adds: 'เพชรบูรณ์ ภาคเหนือ',
                adds_2: 'น้ำตกตาดใหญ่ อ.น้ำหนาว จ.เพชรบูรณ์',
                gogole_link: 'https://goo.gl/maps/cfgjsvoR3yKRkDfT9',
                region_en: 'north',
                region_th: 'ภาคเหนือ',
                desc:`ถ้าแชมเปี้ยนน้ำตกที่ใหญ่ที่สุดในเมืองไทยคือทีลอซู
                        ตำแหน่งของน้ำตกที่สวยที่สุดของเมืองไทย
                        จะต้องมีชื่อของน้ำตกตาดใหญ่เป็นหนึ่งในผู้ท้าชิง
                        เพราะนี่คือน้ำตกที่ได้ชื่อว่าเป็นมุมอันซีนแห่งใหม่ของเมืองไทย
                        กับทิวทัศน์น่าเหลือเชื่อของหุบเขาน้ำตกขนาดยักษ์
                        ที่เราสามารถมองเห็นภาพความมหัศจรรย์ของน้ำตกเหนือทะเลหมอก
                        แต่ถ้าใครอยากสัมผัสน้ำตกแห่งนี้อย่างใกล้ชิด
                        ก็สามารถใช้เส้นทางแอดเวนเจอร์ลัดเลาะจากป่าด้านบนสู่เบื้องล่างของน้ำตก
                        รับรองประกันความชุ่มฉ่ำและความสวยงามระดับห้าดาว
                        ช่วงเวลาที่เหมาะสมแก่การท่องเที่ยว คือ เดือนพฤษภาคม - สิงหาคม`,
                link: `ททท.สำนักงานพิษณุโลก เบอร์โทรศัพท์ <a href="tel:+055252742">0 5525 2742-3 </a> หรือ <a href="tel:+055259907"> 0 5525 9907</a>`
            }],
        }
    },
    mounted() {
        setFunction()
        playVideo()
        this.attractionSlide()
        document.title =   this.bannerArray[0].title + ' '  + this.bannerArray[0].adds_2 + ' ' + this.bannerArray[0].region_th;
        document
            .querySelector('meta[name="keywords"]')
            .setAttribute("content", this.bannerArray[0].location + ' ' + this.bannerArray[0].adds_2 + ' ' + this.bannerArray[0].region_th);
        document
            .querySelector('meta[name="description"]')
            .setAttribute("content", this.bannerArray[0].desc);

            var loadPage = ''
        setTimeout(() => {
            loadPage = 'true'
        }, 2000);
        var isloadeLoop =  setInterval(() => {
            if(loadPage != ''){
            if (document.querySelectorAll('.loadpage-com').length !== 0) {
                document.querySelector('.loadpage-com').classList.remove('active')
            }
                setTimeout(() => {
                    this.isloade = false;
                    clearInterval(isloadeLoop);
                }, 200);
        }else{
            this.isloade = true;
        }
            
        }, 1000);
    },
    methods: {
        attractionSlide() {
            this.attractionSlideInit = new Swiper('.box-arttraction-slide .arttraction_slide', {
                spaceBetween: 10,
                slidesPerView: 'auto',
                loop: true,

                pagination: {
                    el: '.box-arttraction-slide .swiper-pagination',
                    type: 'bullets',
                    clickable: true
                },
                centeredSlides: true,
                speed: 2000,
                autoplay: {
                    delay: 1000,
                    disableOnInteraction: true,
                },
                breakpoints: {
                    767: {
                        centeredSlides: false,
                        loop: false,
                        spaceBetween: 25,
                        slidesPerView: 'auto',
                        simulateTouch: true,
                    },
                },

            });

        },
        
    },

}
</script>

<style>
 

.bg-77vote {
    background-image: url(@/assets/list-detail/north/phetchabun/phetchabun-detail-banner.jpg);
    position: relative;
    background-size: 100%;
    background-position: top;
}

.ele-kv-cloud-detail {
    position: absolute;
    width: 1920px;
    z-index: 1;
    top: 200px;
    transform: translateY(200px);
}

.ele-kv-cloud-detail-m {
    position: absolute;
    z-index: 1;
    bottom: 54%;
    transform: translateY(-54%);
    left: -14%;
    width: 120%;
}

.attractiondtl-detail-sec.pd {
    padding-top: 20px;
}

.attracbanner-title {
    margin-bottom: 200px;
    margin-top: 3rem;
}

.attrac-detail-conts {
    padding: 0 30px;
}

.attrac-detail-conts p {
    font-weight: 300;
}

.sec-attractions-detail .box-title,
.box-subtitle {
    margin-top: 20px;
    text-align: left;
    margin-left: 50px;
}

/* .location-swiper {
    padding: 30px 0;
} */
.newbottom-btn {
    margin-top: 48px;
}

.location-tel .txt-location a {
    color: rgb(248, 249, 250);
}

.swiper-slide img.attrac-img {
    height: 290px;
    width: auto;
    object-fit: contain;
}

.location-tel {
    display: flex;
    align-items: center;
    width: 100%;
    border-top: 1px solid #E4E4E4;
    padding-top: 15px;
    margin-top: 15px;
}

.location-txt svg path {
    stroke: rgb(248, 249, 250);
}

.location-tel svg path {
    stroke: rgb(248, 249, 250);
}

.attrac-detail-video {
    margin-top: -70px;
}

.sec-attractions-detail .box-video {
    padding: 10px;
    border-radius: 13px;
    background-color: #fff;
}

.attrac-img {
    border-radius: 13px;
}

.box-location-slide .swiper {
    overflow: visible;
}

.sec-attractions-detail .video-space {
    border-radius: 13px;
}

.sec-attractions-detail .video-space img {
    border-radius: 13px;
}

.attrac-banner-conts {
    font-size: 1rem;
    padding: 30px 0;
}

.attractiondtl-detail-conts {
    border-radius: 18px;
    padding: 30px 50px;
    text-align: left;
    position: relative;
    z-index: 1;
}

.txt-sub-link {
    font-weight: 300;
    text-decoration: none !important;
    color: #fff !important;
}

.txt-sub-link:hover {
    color: #EC268F !important;
}

.box-arttraction-slide {
    position: relative;
}

.location-slide-con .card-cont {
    width: 100%;
    margin-right: 0;
}

.box-arttraction-slide .swiper-pagination .swiper-pagination-bullet {
    background-color: #d9d9d9;
}

.ele-left-cloud-new {
    top: 20%;
    left: 0;
    margin-left: -30%;
    width: 49%;
}

.ele-right-cloud-new {
    top: 0;
    right: 0;
    margin-right: -40%;
    width: 49%;
}

.box-arttraction-slide .swiper-pagination .swiper-pagination-bullet-active {
    background-color: #EC268F;
}

.box-arttraction-slide .swiper-pagination {
    bottom: -10px !important;
    position: relative;
}

.attrac-detail-video .video-put {
    border-radius: 18px;
    overflow: hidden;
}

.sec-attraction-foot {
    position: relative;
}

.bg-foot-attraction {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    background: rgb(255, 244, 250);
    background: linear-gradient(360deg, rgba(255, 244, 250, 1) 0%, rgba(255, 194, 227, 1) 100%);
}

.swiper-container {
    width: 100%;
    height: 100%;
}

.swiper-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

@media (max-width: 991.98px) {
    .tmr-l-1 {
        font-size: 1.2em;
    }

    .tmr-l-2 {
        font-size: 1em;
    }

    .tmr-c {
        font-size: 3.5em;
    }

    .vote77 .tab-list a {
        font-size: 0.9em;
    }

    .ele-kv-cloud-detail {
        bottom: 0;
        top: unset;
    }
}

@media (max-width: 767.98px) {
    .sec-attractions.bg-77vote {
        background-image: url(@/assets/list-detail/north/phetchabun/phetchabun-detail-banner-m.jpg);
    }

    .ele-left-cloud-new {
        display: none;

    }

    .ele-kv-cloud-detail-m {
        bottom: 40%;
        transform: translateY(-40%);
    }

    .ele-right-cloud-new {
        display: none;
    }

    .bg-77vote .box-title {
        margin-top: -80px;
    }

    .sec-attractions-detail .box-title {
        font-size: 2vw;
    }

    .attracbanner-title {
        margin-bottom: 170px;
    }

    .st.sec.vote77 {
        padding: 0;
        margin-top: -90px;
    }

    .sec-attractions-detail.bg-banner {
        background-size: 100%;
        background-position: top;
    }

    .attractiondtl-detail-conts {
        padding: 20px 30px;
        top: -90px;
    }

    .sec-attractions-detail .box-title,
    .box-subtitle {
        margin-top: 0px;
        text-align: left;
        margin-bottom: 40px;
        margin-left: 0px;
    }

    .sec-attractions-detail .box-subtitle {
        position: relative;
        top: -130px;
    }

    .vote77 .sec-tab ul {
        width: calc(100% + 20px);
        margin-left: -20px;
        padding-left: 20px
    }

    .sec-attractions.sec-banner-main {
        height: 370px;
    }

    .vote77 .sec-tab {
        overflow: hidden;
    }

}

@media (max-width: 575.98px) {

    .sec-attractions.sec-banner-main {
        height: 260px;
    }

    .attrac-dtail-conts {
        margin-top: -20px;
    }

    .st.sec.vote77 {
        padding-bottom: 40px;
    }

    .attrac-detail-conts {
        padding: 10px;
    }

    .attractiondtl-slide-sec.pd {
        padding-bottom: 20px;
    }

    .attractiondtl-detail-sec.pd {
        padding-top: 10px;
    }

    .ele-kv-cloud-detail-m {
        bottom: 61%;
        transform: translateY(-60%);
    }
}</style>
